import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;
const { ui } = constants.colors;

const white = ui.white[500];

export const folderContainer = {
  display: "flex",
  position: "relative",
  justifyContent: "center",
  width: "100%",
  marginTop: "40px",
  padding: "16px 16px",
  maxWidth: "1280px",
  backgroundColor: white,
  alignSelf: "center",
  [mq.downTo(xs)]: {
    borderRadius: "24px",
    padding: "24px 24px",
  },
};
